import { render, staticRenderFns } from "./Cuestionario.vue?vue&type=template&id=ebd3a942&scoped=true"
import script from "./Cuestionario.vue?vue&type=script&lang=js"
export * from "./Cuestionario.vue?vue&type=script&lang=js"
import style0 from "./Cuestionario.vue?vue&type=style&index=0&id=ebd3a942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd3a942",
  null
  
)

export default component.exports